import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/HomePage.tsx';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import AuthProvider from '../context/AuthProvider.tsx';
import RequireAuth from './RequireAuth.tsx';
import LoginPage from '../pages/LoginPage.tsx';
import NotFoundPage from '../pages/NotFoundPage.tsx';
import CapsulePage from '../pages/CapsulePage.tsx';
import Layout from './Layout.tsx';
import CameraPage from '../pages/CameraPage.tsx';
import AboutPage from '../pages/AboutPage.tsx';
import FriendsPage from '../pages/FriendsPage.tsx';
import ProfilePage from '../pages/Profile/ProfilePage.tsx';
import ShopPage from '../pages/Shop/ShopPage.tsx';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage.tsx';
import TermsOfServicePage from '../pages/TermsOfServicePage.tsx';
import ContactPage from '../pages/ContactPage.tsx';

const queryClient = new QueryClient();

function App() {


  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />  
            <Route path="/" element={<RequireAuth><HomePage /></RequireAuth>} />
            <Route path="/friends" element={<RequireAuth><FriendsPage /></RequireAuth>} />
            <Route path="/shop" element={<RequireAuth><ShopPage /></RequireAuth>} />
            <Route path="/profile/:id" element={<RequireAuth><ProfilePage /></RequireAuth>} />
            <Route path="/capsule/:id" element={<RequireAuth><CapsulePage /></RequireAuth>} />
            <Route path="/camera/:id" element={<RequireAuth><CameraPage /></RequireAuth>} />
          </Routes>
        </Layout>
      </AuthProvider>
    </QueryClientProvider> 
  );
}

export default App;
